import React, { useState } from "react";
import { Button, Flex, Form, Input, message, Modal, Row, Typography } from "antd";
import { LockOutlined, UserOutlined, MailOutlined } from "@ant-design/icons";
const { Title } = Typography;

export const ForgotPassword = ({ isModalOpen, handleCancel }) => {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const handleOk = () => {
    // setIsModalOpen(false);
  };

  const onChange = (text) => {
    console.log("onChange:", text);
  };

  const sharedProps = {
    onChange,
  };

  const handleConfirm = () => {
    if (step === 1) {
      setStep(2);
    } else if (step === 2) {
      setStep(3);
    } else if (step === 3) {
      console.log("Password:", password);
      console.log("Confirm Password :", confirmPassword);
      console.log("Password Changed");
      handleCancel();
    }
  };

  const getOkText = () => {
    if (step === 1) return "Send OTP";
    if (step === 2) return "Verify OTP";
    if (step === 3) {
      return "Reset Password";
    }
  };

  const isConfirmDisabled = () => {
    if (step === 1) {
      return !email;
    }
    if (step === 2) {
      return otp;
    }
    if (step === 3) {
      return !(password && confirmPassword && password === confirmPassword);
    }
    return true;
  };

  return (
    <>
      <>
        <Modal
          open={isModalOpen}
          onOk={handleConfirm}
          okText={getOkText()}
          onCancel={handleCancel}
          okButtonProps={{ disabled: isConfirmDisabled() }}
        >
          <Title level={5} style={{ fontSize: "30px", color: "#" }}>
            Forgot Password
          </Title>

          {step === 1 && (
            <>
              <Title level={5}>Enter Email</Title>
              <Form.Item
                name="email"
                rules={[
                  { required: true, message: "Please enter your email!" },
                  { type: "email", message: "Please enter a valid email!" },
                ]}
              >
                <Input
                  size="large"
                  prefix={<MailOutlined />}
                  placeholder="Enter Email"
                  onChange={(e) => setEmail(e.target.value)}
                />
              </Form.Item>
            </>
          )}
          {step === 2 && (
            <>
              <Title level={5}>Enter OTP</Title>
              <Form.Item
                name="otp"
                rules={[{ required: true, message: "Please input OTP!" }]}
              >
                <Input.OTP
                  size="large"
                  formatter={(str) => str.toUpperCase()}
                  {...sharedProps}
                  value={otp}
                />
              </Form.Item>
            </>
          )}
          {step === 3 && (
            <>
              <Title level={5}>Enter New Password</Title>
              <Form.Item
                name="newPassword"
                rules={[
                  { required: true, message: "please enter new password" },
                ]}
              >
                <Input.Password
                  prefix={<LockOutlined />}
                  type="password"
                  placeholder="Password"
                  size="large"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </Form.Item>

              <Form.Item
                name="confirmPassword"
                rules={[
                  { required: true, message: "please enter confirm password" },
                ]}
              >
                <Input.Password
                  prefix={<LockOutlined />}
                  type="password"
                  placeholder="Password"
                  style={{ marginTop: "20px", marginBottom: "10px" }}
                  size="large"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
              </Form.Item>
            </>
          )}
        </Modal>
      </>
    </>
  );
};
